import { createContext } from 'react';
var NotificationContext = createContext({
  notification: null,
  addNotification: function addNotification() {},
  clearNotification: function clearNotification() {}
});
export default NotificationContext;